import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
//import globalcontext
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetBatchsByTrainerId } from '../../service/BatchService';
import { GetByTrainerId } from '../../service/LessonPlannerService';
import { GetByUserId } from '../../service/ForumService';

function Dashboard() {
  const { isLoading, setIsLoading, isAppError, setAppError, appErrorMessage, setAppErrorMessage, appErrorTitle, setAppErrorTitle, appErrorMode, setAppErrorMode, appUser } = useGlobalContext();

  const [batchs, setBatchs] = useState();
  const [keyword, setKeyword] = useState('');
  const [lessonPlanners, setLessonPlanners] = useState([]);
  const [lessonPlanner, setLessonPlanner] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const [totalBatches, setTotalBatches] = useState(0);
  const [todayPlanners, setTodayPlanners] = useState(0);
  const [totalForums, setTotalForums] = useState(0);

  const itemsPerPage = 10;

  const id = appUser._id; // Get the trainer ID from the appUser context

  const fetchBatchList = async (page = 1) => {
    try {
      setIsLoading(true);
      var response = await GetBatchsByTrainerId(id, page, itemsPerPage);
      setBatchs(response.batches);
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
      setTotalBatches(response.totalItems); // total mapped batches
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  //fetch lesson planners by trainer id
  const fetchLessonPlanners = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await GetByTrainerId(id, page, itemsPerPage);
      setLessonPlanners(response.lessonPlanners);
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
      setTodayPlanners(response.totalItems);

    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load lesson planners");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };


  //fetch forum by UserId
  const fetchForumsByUserId = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await GetByUserId(id, page, itemsPerPage);
      setTotalForums(response.totalItems || 0);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load forums");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  function formatTimeWithAMPM(timeStr) {
    const [hours, minutes] = timeStr.split(":").map(Number);

    const date = new Date();
    date.setHours(hours, minutes, 0); // Set time

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });
  }

  React.useEffect(() => {
    fetchLessonPlanners(currentPage);
  }, []);

  React.useEffect(() => {
    fetchBatchList();
    fetchForumsByUserId();
  }, []);

  
  return (
    <>
      <div className='container'>

        {/* start of page */}
        <div className='page'>

          <div className='page-heading'>
            <h1>Dashboard</h1>
          </div>

          {/* start of page content */}
          <div className='page-content'>

            {/* start of dashboard counter section */}
            <div className='dashboard-counter-section'>
              <div className='row'>
                <div className='col-12 col-sm-6 col-md-4 col-lg-4'>
                  <div className='dashboard-counter dashboard-counter-blue'>
                    <i class="bi bi-collection"></i>
                    <span className='counter-value'> {totalBatches} </span>
                    <b>Total Mapped Batches</b>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-md-4 col-lg-4'>
                  <div className='dashboard-counter dashboard-counter-brown'>
                    <i class="bi bi-journal-text"></i>
                    <span className='counter-value'> {todayPlanners} </span>
                    <b>Today's Lesson Planner</b>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-md-4 col-lg-4'>
                  <div className='dashboard-counter dashboard-counter-pink'>
                    <i class="bi bi-chat-dots"></i>
                    <span className='counter-value'> {totalForums} </span>
                    <b>Total Forums</b>
                  </div>
                </div>
              </div>
            </div>
            {/* end of dashboard counter section */}

            <div className='row'>

              <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                {/* start of portal content */}
                <div className="portal">
                  {/* start of portal title */}
                  <div className='portal-title-bar'>
                    <h4 className='portal-heading'>
                      Today's Topics to Cover [ <span style={{ color: '#f00', paddingLeft: '5px', paddingRight: '5px' }}>
                        {new Date().toLocaleDateString('en-US', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric'
                        })}
                      </span> ]
                    </h4>
                  </div>
                  {/* end of portal title */}

                  {/* start of portal body */}
                  <div className='portal-body'>
                    <div className='table-content'>
                      <div className="mobile-scroll">
                        <table className='table table-bordered table-condensed'>
                          <thead>
                            <tr>
                              <th>Batch</th>
                              <th>Category</th>
                              <th>Sub Category</th>
                              <th>Course</th>
                              <th>Topic</th>
                              <th>Time</th>
                              <th>Link</th>
                              <th>Status</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(lessonPlanners) && lessonPlanners.length > 0 ? (
                              lessonPlanners.map((lessonPlanner) => (
                                <tr key={lessonPlanner._id}>
                                  <td>{lessonPlanner.batchId?.name}</td>
                                  <td>{lessonPlanner.batchId?.courseId?.categoryId?.name}</td>
                                  <td>
                                    {lessonPlanner.batchId?.courseId?.subCategoryIds
                                      ?.map(sub => sub.name)
                                      .join(", ")}
                                  </td>
                                  <td>{lessonPlanner.batchId?.courseId?.name}</td>
                                  <td>{lessonPlanner.lessonTopic}</td>
                                  <td>{formatTimeWithAMPM(lessonPlanner.lessonTime)}</td>
                                  <td>
                                    {lessonPlanner.link ? (
                                      <a href={lessonPlanner.link} target="_blank" rel="noopener noreferrer">
                                        Join
                                      </a>
                                    ) : (
                                      <span>—</span>
                                    )}
                                  </td>
                                  <td>{lessonPlanner.status.charAt(0).toUpperCase() + lessonPlanner.status.slice(1)}</td>
                                  <td>
                                    <Link to={`/batch/summary/manage/${lessonPlanner.batchId?._id}`} className='btn btn-sm btn-primary' style={{ marginTop: '5px' }}>
                                      <FontAwesomeIcon icon="fa-solid fa-eye" /> Batch Summary
                                    </Link>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center">No lesson planners found.</td>
                              </tr>
                            )}
                          </tbody>

                        </table>
                      </div>
                    </div>
                  </div>
                  {/* end of portal title */}

                </div>
                {/* end of portal content */}
              </div>
            </div>
            <br></br>
          </div>
          {/* end of page content */}

        </div>
        {/* end of page */}

      </div>
    </>
  )
}

export default Dashboard